module.exports = __webpack_public_path__ + "img/security-audit-img-5.d63572db.webp";